module.exports = __webpack_public_path__ + "static/media/homepage-section-6-phone-4.87f0b562.png";